import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin, Linkedin, Twitter } from 'lucide-react'
import logoImage from '../../assets/images/C9LogoDarkTheme.png'

export default function Footer() {
  return (
    <footer className="bg-c9-blue text-white">
      <div className="container-full py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 pt-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src={logoImage} 
                alt="C9 Recruitment Logo - Dark Theme" 
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-gray-300 mb-4">
              Efficient recruitment solutions for transport & logistics. 
              Your trusted partner in finding reliable staff.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-c9-orange transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-c9-orange transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/clients" className="text-gray-300 hover:text-white transition-colors">Our Services</Link></li>
              <li><Link to="/candidates" className="text-gray-300 hover:text-white transition-colors">For Candidates</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-white transition-colors">Knowledge Hub</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Contingency Recruitment</li>
              <li>Executive Search</li>
              <li>Temporary Staffing</li>
              <li>Project Campaigns</li>
              <li>Built to Fit Solutions</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-c9-orange mt-0.5 flex-shrink-0" />
                <div className="text-gray-300">
                  <p>Albany House,</p>
                  <p>162-168 High Street,</p>
                  <p>Waltham Cross, EN8 7DF</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-c9-orange" />
                <span className="text-gray-300">020 8152 4574</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-c9-orange" />
                <span className="text-gray-300">contact@c9-recruitment.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-600 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-300 text-sm">
            2025 C9 Recruitment. All rights reserved.
          </div>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-300 hover:text-white text-sm transition-colors">
              Privacy Policy
            </Link>
            <a href="#" className="text-gray-300 hover:text-white text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
